export default function checkErrorPages() {
    const newLevels = null;
    const isError = false;

    return { isError, levels: newLevels };
}
